type FieldLocale = {
  readonly locale: string;
  readonly value: any;
};

export const getFieldFromLocale = (
  allFieldLocales: readonly FieldLocale[],
  locale: string
) => {
  const field = allFieldLocales.find(
    (fieldLocale) => fieldLocale.locale === locale
  )?.value;
  return field;
};
